var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfigureKey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.42506 0C7.47504 0 5.85011 1.63313 5.85011 3.59287C5.85011 4.11552 5.98015 4.57276 6.17515 5.03001L0 11.1709L1.81998 13L3.05496 11.7588L4.35501 13L5.19998 12.1508L5.97999 12.9347L6.89003 12.0201L4.87505 9.99502L7.99508 6.85934C8.45005 7.05532 8.90513 7.18601 9.42506 7.18601C11.3751 7.18601 13 5.55289 13 3.59315C13 1.63324 11.375 0 9.42506 0ZM9.42506 5.22594C8.51501 5.22594 7.80008 4.50742 7.80008 3.59281C7.80008 2.6782 8.51501 1.95968 9.42506 1.95968C10.3351 1.95968 11.05 2.6782 11.05 3.59281C11.05 4.50742 10.3351 5.22594 9.42506 5.22594Z",
    fill: "white",
    fillOpacity: 0.37
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigureKey);
export default __webpack_public_path__ + "static/media/configure-key.63e87dc6675460d0b16648456992e65f.svg";
export { ForwardRef as ReactComponent };